export interface IReissueDiscountRequest {
  priorLoanDate?: string;
  priorLoanAmount?: number;
  payoffBalance?: number;
  applied: boolean;
}

export type IReissueDiscountResponse = IReissueDiscountRequest & {
  id: string;
};

export interface IReissueDiscountData {
  id: string;
  priorLoanDate?: string;
  priorLoanAmount?: number;
  payoffBalance?: number;
  applied: boolean;
}

export const convertFromReissueDiscountDataToReissueDiscountResponse = (
  data: IReissueDiscountData
): IReissueDiscountResponse => data;

export const convertFromReissueDiscountResponseToReissueDiscountData = (
  data: IReissueDiscountResponse
): IReissueDiscountData => data;

export const convertFromReissueDiscountDataToReissueDiscountRequest = (
  data: IReissueDiscountData
): IReissueDiscountRequest => data;
